<template>
    <div>
      <h1>Página no encontrada</h1>
      <p>Lo sentimos, la página que buscas no se encuentra.</p>
      <!-- Agrega aquí enlaces o contenido adicional -->
    </div>
</template>
  
<script>
  export default {
    name: 'NotFound'
  }
</script>
  
<style scoped>
  /* Estilos para el componente NotFound.vue */
</style>
  